"use client";

import Image from "next/image";
import profile from "@/assets/imgs/profile.jpeg";
import refercv from "@/assets/imgs/refer-cv.jpeg";
import realtime from "@/assets/imgs/realtime-connect.jpeg";
import { useClientTranslations } from "@/lib/translate";

export const OurVisions = () => {
  const { t } = useClientTranslations("vision");

  const visions = [
    {
      icon: (
        <Image
          src={profile}
          alt="Xây dựng hồ sơ với Together Work"
          width={2300}
          height={2300}
          className="size-32"
        />
      ),
      title: t("cv.title"),
      description: t("cv.description"),
    },
    {
      icon: (
        <Image
          src={refercv}
          alt="Refer CV với Together Work"
          width={2300}
          height={2300}
          className="size-32"
        />
      ),
      title: t("refer.title"),
      description: t("refer.description"),
    },
    {
      icon: (
        <Image
          src={realtime}
          alt="Kết nối với doanh nghiệp qua Together Work"
          width={2300}
          height={2300}
          className="size-32"
        />
      ),
      title: t("connect.title"),
      description: t("connect.description"),
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold sm:text-4xl text-primary">
            {t("why")}
          </h2>
          {/* <p className="mt-4 text-lg text-gray-600">
            Chúng tôi cam kết mang đến những giải pháp tốt nhất cho sự nghiệp
            của bạn
          </p> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 xl:gap-16">
          {visions.map((vision, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex flex-col items-center text-center">
                <div className="flex items-center justify-center mb-6">
                  {vision.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {vision.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {vision.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

OurVisions.displayName = "OurVisions";
